import React, { HTMLAttributes } from "react";
import { TextInput } from "./TextInput";
import { Icon } from "../Icon/icon";
import { InputError } from "../InputError/InputError";
import {
  FormFieldProps,
  FormFieldMultiString,
  FormFieldString,
} from "../../commonTypes/formField.types";
import { shortuid } from "../../utils/guid";
import { hashCode } from "../../utils/hash";
import { InputInfo } from "../InputInfo/inputInfo";
export interface TextInputGroupProps extends FormFieldProps<string[]> {
  placeholder: string;
  maxLength?: number;
  maxItems?: number;
}

export interface TextInputGroupState extends FormFieldMultiString {
  textInputs: FormFieldString[];
}
const DEFAULT_STATE_VALUE = [""];

export class TextInputGroup extends React.Component<
  TextInputGroupProps,
  TextInputGroupState
> {
  static defaultProps = {
    value: [""],
    fieldName: "textInput",
    placeholder: "",
    isTouched: false,
    maxItems: 9999,
    errorMessage: "",
    onChange: () => {
      /* noop */
    },
  };
  private _id: string;
  private _errorId: string;
  private _latestValue: string[] | undefined;

  constructor(props: any) {
    super(props);
    this._id = props.id || hashCode(props.fieldName, "textInput");
    this._errorId = hashCode(props.id || props.fieldName, "error");

    let textInputs = this.props.value.map((s, i) => {
      return {
        value: s,
        fieldName: this.createUniqFieldName(this.props.fieldName),
      };
    });
    const { fieldName, value, isRequired, label } = this.props;

    if (props.value !== undefined) {
      this._latestValue = value;
    } else {
      this._latestValue = DEFAULT_STATE_VALUE;
    }

    this.state = {
      value: this._latestValue,
      fieldName,
      isRequired,
      label,
      textInputs,
    };
  }

  private createUniqFieldName(fieldName: string) {
    var uuid = shortuid();
    return `${fieldName}.${uuid}`;
  }

  private get _errorMessage(): string | undefined {
    let { errorMessage } = this.state;
    if (!errorMessage && this.props.errorMessage) {
      errorMessage = this.props.errorMessage;
    }

    return errorMessage;
  }

  componentWillUnmount() {
    this.clearChildrenFromStore();
  }

  clearChildrenFromStore() {
    const { onChange, fieldName } = this.props;
    onChange({ fieldName, value: DEFAULT_STATE_VALUE });
  }

  onAddMore = (e: React.MouseEvent) => {
    e.preventDefault();
    this.setState((prevState) => {
      const newTextInputs = prevState.textInputs.slice();
      newTextInputs.push({
        value: "",
        fieldName: this.createUniqFieldName(this.props.fieldName),
      });
      return {
        textInputs: newTextInputs,
      };
    });
  };

  onRemove = (inputState: FormFieldString) => {
    this.setState(
      (prevState) => {
        const { textInputs } = prevState;
        let newTextInputs = textInputs.slice();
        let index = newTextInputs.findIndex(
          (f) => f.fieldName === inputState.fieldName
        );
        newTextInputs.splice(index, 1);
        const value = newTextInputs.map((i) => i.value);
        return {
          value: value,
          textInputs: newTextInputs,
        };
      },
      () => {
        this.props.onChange(this.state);
      }
    );
  };
  onChangeValue = (inputState: FormFieldString) => {
    this.setState(
      (prevState) => {
        const { textInputs } = prevState;
        let newTextInputs = textInputs.slice();
        let index = newTextInputs.findIndex(
          (f) => f.fieldName === inputState.fieldName
        );
        if (index === -1) {
          //newTextInputs.push(inputState);
        } else {
          newTextInputs[index] = inputState;
        }
        const value = newTextInputs.map((i) => i.value);
        return {
          value: value,
          textInputs: newTextInputs,
          isTouched: true,
        };
      },
      () => {
        this.props.onChange(this.state);
      }
    );
  };
  public render() {
    const { placeholder, maxLength, maxItems } = this.props;
    const { textInputs } = this.state;
    const errorMessage = this._errorMessage;

    let ariaAttributes = {} as HTMLAttributes<any>;
    if (errorMessage) {
      ariaAttributes["aria-invalid"] = true;
      ariaAttributes["aria-describedby"] = this._errorId;
    } else {
      ariaAttributes = null;
    }

    return (
      <div className="textinput-grp">
        {textInputs.map((t, i, arr) => (
          <div key={`${t.fieldName}_${i}`} className="textinput-item">
            <TextInput
              key={t.fieldName}
              fieldName={t.fieldName}
              value={t.value}
              placeholder={placeholder}
              onChange={this.onChangeValue}
              changeOnBlur
              maxLength={maxLength}
              errorAriaAttributes={ariaAttributes}
            />
            {i > 0 && (
              <div className="textinput-grp__control-row">
                <button className="remove" onClick={(e) => this.onRemove(t)}>
                  Ta bort <Icon iconType="Paperbin" />
                </button>
              </div>
            )}
          </div>
        ))}
        {textInputs.length < maxItems && (
          <div className="textinput-grp__control-row">
            <button className="add" onClick={this.onAddMore}>
              Lägg till fler{" "}
              <Icon iconType="baseline-add_circle_outline-24px" />
            </button>
          </div>
        )}
        {textInputs.length >= maxItems && (
          <InputInfo infoText={`Du kan som mest ange ${maxItems} datakällor`} />
        )}
        {errorMessage && (
          <InputError id={this._errorId} errorText={errorMessage} />
        )}
      </div>
    );
  }
}
